import ai from './ai';
import bodyHTML from './bodyHTML';
import conditionDescription from './conditionDescription';
import description from './description';
import details from './details';
import files from './files';
import inventory from './inventory';
import keywords from './keywords';
import materials from './materials';
import metaDescription from './metaDescription';
import pageTitle from './pageTitle';
import personalization from './personalization';
import photos from './photos';
import processingProfile from './processingProfile';
import shipping from './shipping';
import tags from './tags';
import title from './title';
import variations from './variations';
import videos from './videos';
import { getSize } from '../../iterable/getSize';

import { EBAY, ETSY, FAIRE, SHOPIFY } from '../../../constants/channels';
import { OPERATIONS } from '../../../constants/bulkEdit';

function applyOperationToProduct(props) {
  const { actions, operation, product } = props;
  const channel = product.get('channel');
  const operationType = operation.get('type');

  switch (channel) {
    case EBAY: {
      switch (operationType) {
        case OPERATIONS[EBAY].AI: {
          return ai(props);
        }

        case OPERATIONS[EBAY].CONDITION_ID:
        case OPERATIONS[EBAY].ITEM_CATEGORY:
        case OPERATIONS[EBAY].ITEM_SPECIFICS.SET:
        case OPERATIONS[EBAY].ITEM_SPECIFICS.UPDATE:
        case OPERATIONS[EBAY].PRODUCT_DETAILS.SET:
        case OPERATIONS[EBAY].PRODUCT_DETAILS.UPDATE:
        case OPERATIONS[EBAY].STORE_CATEGORY: {
          return details(props);
        }

        case OPERATIONS[EBAY].KEYWORDS.SET: {
          return keywords(props);
        }
        case OPERATIONS[EBAY].CONDITION_DESCRIPTION.ADD_AFTER:
        case OPERATIONS[EBAY].CONDITION_DESCRIPTION.ADD_BEFORE:
        case OPERATIONS[EBAY].CONDITION_DESCRIPTION.DELETE:
        case OPERATIONS[EBAY].CONDITION_DESCRIPTION.FIND_AND_REPLACE:
        case OPERATIONS[EBAY].CONDITION_DESCRIPTION.SET: {
          return conditionDescription(props);
        }

        case OPERATIONS[EBAY].DESCRIPTION.ADD_AFTER:
        case OPERATIONS[EBAY].DESCRIPTION.ADD_BEFORE:
        case OPERATIONS[EBAY].DESCRIPTION.DELETE:
        case OPERATIONS[EBAY].DESCRIPTION.FIND_AND_REPLACE:
        case OPERATIONS[EBAY].DESCRIPTION.SET: {
          return bodyHTML(props);
        }

        case OPERATIONS[EBAY].PHOTOS.ADD:
        case OPERATIONS[EBAY].PHOTOS.CHANGE_TO:
        case OPERATIONS[EBAY].PHOTOS.DELETE:
        case OPERATIONS[EBAY].PHOTOS.REPLACE:
        case OPERATIONS[EBAY].PHOTOS.SWAP:
        case OPERATIONS[EBAY].PHOTOS.UPDATE: {
          return photos(props);
        }

        case OPERATIONS[EBAY].PRICE.CHANGE_TO:
        case OPERATIONS[EBAY].PRICE.DECREASE_BY:
        case OPERATIONS[EBAY].PRICE.INCREASE_BY:
        case OPERATIONS[EBAY].QUANTITY.CHANGE_TO:
        case OPERATIONS[EBAY].QUANTITY.DECREASE_BY:
        case OPERATIONS[EBAY].QUANTITY.INCREASE_BY:
        case OPERATIONS[EBAY].SKU.DELETE:
        case OPERATIONS[EBAY].SKU.CHANGE_TO:
        case OPERATIONS[EBAY].SKU.ADD_AFTER:
        case OPERATIONS[EBAY].SKU.ADD_BEFORE:
        case OPERATIONS[EBAY].SKU.FIND_AND_REPLACE: {
          return inventory(props);
        }

        case OPERATIONS[EBAY].COUNTRY:
        case OPERATIONS[EBAY].DEPTH.DECREASE_BY:
        case OPERATIONS[EBAY].DEPTH.INCREASE_BY:
        case OPERATIONS[EBAY].DEPTH.SET:
        case OPERATIONS[EBAY].IRREGULAR:
        case OPERATIONS[EBAY].LENGTH.DECREASE_BY:
        case OPERATIONS[EBAY].LENGTH.INCREASE_BY:
        case OPERATIONS[EBAY].LENGTH.SET:
        case OPERATIONS[EBAY].LOCATION:
        case OPERATIONS[EBAY].PAYMENT_POLICY:
        case OPERATIONS[EBAY].POSTAL_CODE:
        case OPERATIONS[EBAY].RETURN_POLICY:
        case OPERATIONS[EBAY].SHIPPING_POLICY:
        case OPERATIONS[EBAY].WEIGHT_MAJOR.DECREASE_BY:
        case OPERATIONS[EBAY].WEIGHT_MAJOR.INCREASE_BY:
        case OPERATIONS[EBAY].WEIGHT_MAJOR.SET:
        case OPERATIONS[EBAY].WEIGHT_MINOR.DECREASE_BY:
        case OPERATIONS[EBAY].WEIGHT_MINOR.INCREASE_BY:
        case OPERATIONS[EBAY].WEIGHT_MINOR.SET:
        case OPERATIONS[EBAY].WIDTH.DECREASE_BY:
        case OPERATIONS[EBAY].WIDTH.INCREASE_BY:
        case OPERATIONS[EBAY].WIDTH.SET: {
          return shipping(props);
        }

        case OPERATIONS[EBAY].TITLE.ADD_AFTER:
        case OPERATIONS[EBAY].TITLE.ADD_BEFORE:
        case OPERATIONS[EBAY].TITLE.DELETE:
        case OPERATIONS[EBAY].TITLE.FIND_AND_REPLACE:
        case OPERATIONS[EBAY].TITLE.SET: {
          return title(props);
        }

        case OPERATIONS[EBAY].VARIATIONS: {
          return variations(props);
        }

        case OPERATIONS[EBAY].VIDEOS.ADD:
        case OPERATIONS[EBAY].VIDEOS.CHANGE_TO:
        case OPERATIONS[EBAY].VIDEOS.DELETE:
        case OPERATIONS[EBAY].VIDEOS.REPLACE: {
          return videos(props);
        }

        default: {
          return { actions, product };
        }
      }
    }

    case ETSY: {
      switch (operationType) {
        case OPERATIONS[ETSY].AI: {
          return ai(props);
        }

        case OPERATIONS[ETSY].CATEGORY:
        case OPERATIONS[ETSY].IS_SUPPLY:
        case OPERATIONS[ETSY].PRODUCTION_PARTNERS:
        case OPERATIONS[ETSY].SECTION:
        case OPERATIONS[ETSY].TAXONOMY_ATTRIBUTES:
        case OPERATIONS[ETSY].WHO_MADE:
        case OPERATIONS[ETSY].WHEN_MADE: {
          return details(props);
        }

        case OPERATIONS[ETSY].DESCRIPTION.ADD_AFTER:
        case OPERATIONS[ETSY].DESCRIPTION.ADD_BEFORE:
        case OPERATIONS[ETSY].DESCRIPTION.DELETE:
        case OPERATIONS[ETSY].DESCRIPTION.FIND_AND_REPLACE:
        case OPERATIONS[ETSY].DESCRIPTION.SET: {
          return description(props);
        }

        case OPERATIONS[ETSY].FILES.ADD:
        case OPERATIONS[ETSY].FILES.CHANGE_TO:
        case OPERATIONS[ETSY].FILES.DELETE:
        case OPERATIONS[ETSY].FILES.REPLACE:
        case OPERATIONS[ETSY].FILES.SWAP: {
          return files(props);
        }

        case OPERATIONS[ETSY].MATERIALS.ADD:
        case OPERATIONS[ETSY].MATERIALS.CHANGE_TO:
        case OPERATIONS[ETSY].MATERIALS.DELETE: {
          return materials(props);
        }

        case OPERATIONS[ETSY].PERSONALIZATION.CHAR_COUNT_MAX_SET:
        case OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_ADD_AFTER:
        case OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_ADD_BEFORE:
        case OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_DELETE:
        case OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_FIND_AND_REPLACE:
        case OPERATIONS[ETSY].PERSONALIZATION.INSTRUCTIONS_SET:
        case OPERATIONS[ETSY].PERSONALIZATION.IS_PERSONALIZABLE_SET:
        case OPERATIONS[ETSY].PERSONALIZATION.IS_REQUIRED_SET: {
          return personalization(props);
        }

        case OPERATIONS[ETSY].PHOTOS.ADD:
        case OPERATIONS[ETSY].PHOTOS.CHANGE_TO:
        case OPERATIONS[ETSY].PHOTOS.DELETE:
        case OPERATIONS[ETSY].PHOTOS.REPLACE:
        case OPERATIONS[ETSY].PHOTOS.SWAP:
        case OPERATIONS[ETSY].PHOTOS.UPDATE: {
          return photos(props);
        }

        case OPERATIONS[ETSY].PRICE.CHANGE_TO:
        case OPERATIONS[ETSY].PRICE.DECREASE_BY:
        case OPERATIONS[ETSY].PRICE.INCREASE_BY:
        case OPERATIONS[ETSY].QUANTITY.CHANGE_TO:
        case OPERATIONS[ETSY].QUANTITY.DECREASE_BY:
        case OPERATIONS[ETSY].QUANTITY.INCREASE_BY:
        case OPERATIONS[ETSY].SKU.DELETE:
        case OPERATIONS[ETSY].SKU.CHANGE_TO:
        case OPERATIONS[ETSY].SKU.ADD_AFTER:
        case OPERATIONS[ETSY].SKU.ADD_BEFORE:
        case OPERATIONS[ETSY].SKU.FIND_AND_REPLACE: {
          return inventory(props);
        }

        case OPERATIONS[ETSY].RETURN_POLICY: {
          return shipping(props);
        }

        case OPERATIONS[ETSY].PROCESSING_PROFILE: {
          return processingProfile(props);
        }

        case OPERATIONS[ETSY].SHIPPING_PROFILE:
        case OPERATIONS[ETSY].HEIGHT.DECREASE_BY:
        case OPERATIONS[ETSY].HEIGHT.INCREASE_BY:
        case OPERATIONS[ETSY].HEIGHT.SET:
        case OPERATIONS[ETSY].LENGTH.DECREASE_BY:
        case OPERATIONS[ETSY].LENGTH.INCREASE_BY:
        case OPERATIONS[ETSY].LENGTH.SET:
        case OPERATIONS[ETSY].WEIGHT.DECREASE_BY:
        case OPERATIONS[ETSY].WEIGHT.INCREASE_BY:
        case OPERATIONS[ETSY].WEIGHT.SET:
        case OPERATIONS[ETSY].WIDTH.DECREASE_BY:
        case OPERATIONS[ETSY].WIDTH.INCREASE_BY:
        case OPERATIONS[ETSY].WIDTH.SET: {
          return shipping(props);
        }

        case OPERATIONS[ETSY].TAGS.ADD:
        case OPERATIONS[ETSY].TAGS.DELETE:
        case OPERATIONS[ETSY].TAGS.CHANGE_TO: {
          return tags(props);
        }

        case OPERATIONS[ETSY].TITLE.ADD_AFTER:
        case OPERATIONS[ETSY].TITLE.ADD_BEFORE:
        case OPERATIONS[ETSY].TITLE.DELETE:
        case OPERATIONS[ETSY].TITLE.FIND_AND_REPLACE:
        case OPERATIONS[ETSY].TITLE.SET: {
          return title(props);
        }

        case OPERATIONS[ETSY].VARIATIONS: {
          return variations(props);
        }

        case OPERATIONS[ETSY].VIDEOS.ADD:
        case OPERATIONS[ETSY].VIDEOS.CHANGE_TO:
        case OPERATIONS[ETSY].VIDEOS.DELETE:
        case OPERATIONS[ETSY].VIDEOS.REPLACE: {
          return videos(props);
        }

        default: {
          return { actions, product };
        }
      }
    }

    case FAIRE: {
      switch (operationType) {
        case OPERATIONS[FAIRE].AI: {
          return ai(props);
        }

        case OPERATIONS[FAIRE].CASE_SIZE.SET:
        case OPERATIONS[FAIRE].MINIMUM_ORDER_QUANTITY.SET:
        case OPERATIONS[FAIRE].PER_STYLE_MINIMUM_ORDER_QUANTITY.SET: {
          return shipping(props);
        }

        case OPERATIONS[FAIRE].CATEGORY: {
          return details(props);
        }

        case OPERATIONS[FAIRE].TITLE.ADD_AFTER:
        case OPERATIONS[FAIRE].TITLE.ADD_BEFORE:
        case OPERATIONS[FAIRE].TITLE.DELETE:
        case OPERATIONS[FAIRE].TITLE.FIND_AND_REPLACE:
        case OPERATIONS[FAIRE].TITLE.SET: {
          return title(props);
        }

        case OPERATIONS[FAIRE].DESCRIPTION.ADD_AFTER:
        case OPERATIONS[FAIRE].DESCRIPTION.ADD_BEFORE:
        case OPERATIONS[FAIRE].DESCRIPTION.DELETE:
        case OPERATIONS[FAIRE].DESCRIPTION.FIND_AND_REPLACE:
        case OPERATIONS[FAIRE].DESCRIPTION.SET: {
          return description(props);
        }

        case OPERATIONS[FAIRE].PHOTOS.ADD:
        case OPERATIONS[FAIRE].PHOTOS.CHANGE_TO:
        case OPERATIONS[FAIRE].PHOTOS.DELETE:
        case OPERATIONS[FAIRE].PHOTOS.REPLACE:
        case OPERATIONS[FAIRE].PHOTOS.SWAP:
        case OPERATIONS[FAIRE].PHOTOS.UPDATE: {
          return photos(props);
        }

        case OPERATIONS[FAIRE].CONTINUE_SELLING.SET:
        case OPERATIONS[FAIRE].DEADLINE_DATE.SET:
        case OPERATIONS[FAIRE].DISTANCE_UNIT:
        case OPERATIONS[FAIRE].END_DATE.SET:
        case OPERATIONS[FAIRE].GTIN.DELETE:
        case OPERATIONS[FAIRE].GTIN.CHANGE_TO:
        case OPERATIONS[FAIRE].GTIN.ADD_AFTER:
        case OPERATIONS[FAIRE].GTIN.ADD_BEFORE:
        case OPERATIONS[FAIRE].GTIN.FIND_AND_REPLACE:
        case OPERATIONS[FAIRE].HEIGHT.DECREASE_BY:
        case OPERATIONS[FAIRE].HEIGHT.INCREASE_BY:
        case OPERATIONS[FAIRE].HEIGHT.SET:
        case OPERATIONS[FAIRE].KEEP_ACTIVE.SET:
        case OPERATIONS[FAIRE].LENGTH.DECREASE_BY:
        case OPERATIONS[FAIRE].LENGTH.INCREASE_BY:
        case OPERATIONS[FAIRE].LENGTH.SET:
        case OPERATIONS[FAIRE].MASS_UNIT:
        case OPERATIONS[FAIRE].PREORDER.SET:
        case OPERATIONS[FAIRE].PRICES.DECREASE_BY:
        case OPERATIONS[FAIRE].PRICES.INCREASE_BY:
        case OPERATIONS[FAIRE].PRICES.SET:
        case OPERATIONS[FAIRE].RESTOCK_DATE.SET:
        case OPERATIONS[FAIRE].QUANTITY.CHANGE_TO:
        case OPERATIONS[FAIRE].QUANTITY.DECREASE_BY:
        case OPERATIONS[FAIRE].QUANTITY.INCREASE_BY:
        case OPERATIONS[FAIRE].SKU.DELETE:
        case OPERATIONS[FAIRE].SKU.CHANGE_TO:
        case OPERATIONS[FAIRE].SKU.ADD_AFTER:
        case OPERATIONS[FAIRE].SKU.ADD_BEFORE:
        case OPERATIONS[FAIRE].SKU.FIND_AND_REPLACE:
        case OPERATIONS[FAIRE].START_DATE.SET:
        case OPERATIONS[FAIRE].TARIFF_CODE.SET:
        case OPERATIONS[FAIRE].WEIGHT.DECREASE_BY:
        case OPERATIONS[FAIRE].WEIGHT.INCREASE_BY:
        case OPERATIONS[FAIRE].WEIGHT.SET:
        case OPERATIONS[FAIRE].WIDTH.DECREASE_BY:
        case OPERATIONS[FAIRE].WIDTH.INCREASE_BY:
        case OPERATIONS[FAIRE].WIDTH.SET: {
          return inventory(props);
        }

        case OPERATIONS[FAIRE].VARIATIONS: {
          return variations(props);
        }

        default: {
          return { actions, product };
        }
      }
    }

    case SHOPIFY: {
      switch (operationType) {
        case OPERATIONS[SHOPIFY].AI: {
          return ai(props);
        }

        case OPERATIONS[SHOPIFY].BARCODE.DELETE:
        case OPERATIONS[SHOPIFY].BARCODE.CHANGE_TO:
        case OPERATIONS[SHOPIFY].BARCODE.ADD_AFTER:
        case OPERATIONS[SHOPIFY].BARCODE.ADD_BEFORE:
        case OPERATIONS[SHOPIFY].BARCODE.FIND_AND_REPLACE:
        case OPERATIONS[SHOPIFY].CAP.CHANGE_TO:
        case OPERATIONS[SHOPIFY].CAP.DECREASE_BY:
        case OPERATIONS[SHOPIFY].CAP.INCREASE_BY:
        case OPERATIONS[SHOPIFY].CAP.COPY_FROM_PRICE:
        case OPERATIONS[SHOPIFY].CHARGE_TAX.SET:
        case OPERATIONS[SHOPIFY].CONTINUE_SELLING.SET:
        case OPERATIONS[SHOPIFY].COUNTRY_CODE.SET:
        case OPERATIONS[SHOPIFY].CPI.CHANGE_TO:
        case OPERATIONS[SHOPIFY].CPI.DECREASE_BY:
        case OPERATIONS[SHOPIFY].CPI.INCREASE_BY:
        case OPERATIONS[SHOPIFY].HS_CODE.SET:
        case OPERATIONS[SHOPIFY].INVENTORY_INLINE_EDIT:
        case OPERATIONS[SHOPIFY].PHYSICAL.SET:
        case OPERATIONS[SHOPIFY].PRICE.CHANGE_TO:
        case OPERATIONS[SHOPIFY].PRICE.DECREASE_BY:
        case OPERATIONS[SHOPIFY].PRICE.INCREASE_BY:
        case OPERATIONS[SHOPIFY].PRICE.COPY_FROM_CAP:
        case OPERATIONS[SHOPIFY].QUANTITY.CHANGE_TO:
        case OPERATIONS[SHOPIFY].QUANTITY.DECREASE_BY:
        case OPERATIONS[SHOPIFY].QUANTITY.INCREASE_BY:
        case OPERATIONS[SHOPIFY].SKU.DELETE:
        case OPERATIONS[SHOPIFY].SKU.CHANGE_TO:
        case OPERATIONS[SHOPIFY].SKU.ADD_AFTER:
        case OPERATIONS[SHOPIFY].SKU.ADD_BEFORE:
        case OPERATIONS[SHOPIFY].SKU.FIND_AND_REPLACE:
        case OPERATIONS[SHOPIFY].TRACK_QUANTITY.SET:
        case OPERATIONS[SHOPIFY].WEIGHT.CHANGE_TO:
        case OPERATIONS[SHOPIFY].WEIGHT.INCREASE_BY:
        case OPERATIONS[SHOPIFY].WEIGHT.DECREASE_BY: {
          return inventory(props);
        }

        case OPERATIONS[SHOPIFY].BARCODE.INLINE_EDIT:
        case OPERATIONS[SHOPIFY].CAP.INLINE_EDIT:
        case OPERATIONS[SHOPIFY].CHARGE_TAX.INLINE_EDIT:
        case OPERATIONS[SHOPIFY].CONTINUE_SELLING.INLINE_EDIT:
        case OPERATIONS[SHOPIFY].COUNTRY_CODE.INLINE_EDIT:
        case OPERATIONS[SHOPIFY].CPI.INLINE_EDIT:
        case OPERATIONS[SHOPIFY].HS_CODE.INLINE_EDIT:
        case OPERATIONS[SHOPIFY].PHYSICAL.INLINE_EDIT:
        case OPERATIONS[SHOPIFY].PRICE.INLINE_EDIT:
        case OPERATIONS[SHOPIFY].QUANTITY.INLINE_EDIT:
        case OPERATIONS[SHOPIFY].SKU.INLINE_EDIT:
        case OPERATIONS[SHOPIFY].WEIGHT.INLINE_EDIT:
        case OPERATIONS[SHOPIFY].VARIATIONS: {
          return variations(props);
        }

        case OPERATIONS[SHOPIFY].DESCRIPTION.ADD_AFTER:
        case OPERATIONS[SHOPIFY].DESCRIPTION.ADD_BEFORE:
        case OPERATIONS[SHOPIFY].DESCRIPTION.DELETE:
        case OPERATIONS[SHOPIFY].DESCRIPTION.FIND_AND_REPLACE:
        case OPERATIONS[SHOPIFY].DESCRIPTION.SET: {
          return bodyHTML(props);
        }

        case OPERATIONS[SHOPIFY].CATEGORY:
        case OPERATIONS[SHOPIFY].COLLECTIONS:
        case OPERATIONS[SHOPIFY].PRODUCT_TYPE:
        case OPERATIONS[SHOPIFY].VENDOR: {
          return details(props);
        }

        case OPERATIONS[SHOPIFY].KEYWORDS.SET: {
          return keywords(props);
        }

        case OPERATIONS[SHOPIFY].META_DESCRIPTION.ADD_AFTER:
        case OPERATIONS[SHOPIFY].META_DESCRIPTION.ADD_BEFORE:
        case OPERATIONS[SHOPIFY].META_DESCRIPTION.DELETE:
        case OPERATIONS[SHOPIFY].META_DESCRIPTION.FIND_AND_REPLACE:
        case OPERATIONS[SHOPIFY].META_DESCRIPTION.SET: {
          return metaDescription(props);
        }

        case OPERATIONS[SHOPIFY].PAGE_TITLE.ADD_AFTER:
        case OPERATIONS[SHOPIFY].PAGE_TITLE.ADD_BEFORE:
        case OPERATIONS[SHOPIFY].PAGE_TITLE.DELETE:
        case OPERATIONS[SHOPIFY].PAGE_TITLE.FIND_AND_REPLACE:
        case OPERATIONS[SHOPIFY].PAGE_TITLE.SET: {
          return pageTitle(props);
        }

        case OPERATIONS[SHOPIFY].PHOTOS.ADD:
        case OPERATIONS[SHOPIFY].PHOTOS.CHANGE_TO:
        case OPERATIONS[SHOPIFY].PHOTOS.DELETE:
        case OPERATIONS[SHOPIFY].PHOTOS.REPLACE:
        case OPERATIONS[SHOPIFY].PHOTOS.SWAP:
        case OPERATIONS[SHOPIFY].PHOTOS.UPDATE: {
          return photos(props);
        }

        case OPERATIONS[SHOPIFY].TAGS.ADD:
        case OPERATIONS[SHOPIFY].TAGS.DELETE:
        case OPERATIONS[SHOPIFY].TAGS.CHANGE_TO: {
          return tags(props);
        }

        case OPERATIONS[SHOPIFY].TITLE.ADD_AFTER:
        case OPERATIONS[SHOPIFY].TITLE.ADD_BEFORE:
        case OPERATIONS[SHOPIFY].TITLE.DELETE:
        case OPERATIONS[SHOPIFY].TITLE.FIND_AND_REPLACE:
        case OPERATIONS[SHOPIFY].TITLE.SET: {
          return title(props);
        }

        case OPERATIONS[SHOPIFY].VIDEOS.ADD:
        case OPERATIONS[SHOPIFY].VIDEOS.CHANGE_TO:
        case OPERATIONS[SHOPIFY].VIDEOS.DELETE:
        case OPERATIONS[SHOPIFY].VIDEOS.REPLACE: {
          return videos(props);
        }

        default: {
          return { actions, product };
        }
      }
    }

    default: {
      return { actions, product };
    }
  }
}

export function applyOperationsToProducts({ actions: actionsToDispatch = [], operations, products, ...rest }) {
  if (getSize(operations) === 0 || getSize(products?.get('byId')) === 0) {
    return { actions: actionsToDispatch, products };
  }

  function reduceOperations(result, operation) {
    return operation.get('products').includes(result.product.get('productId'))
      ? applyOperationToProduct({ operation, ...result, ...rest })
      : result;
  }

  function applyOperationsToProduct(result, product, productId) {
    const updates = operations.reduce(
      reduceOperations,
      {
        actions: result.actions,
        confirmation: result.confirmation,
        product,
      }
    );

    return {
      actions: updates.actions,
      confirmation: updates.confirmation,
      products: result.products.setIn(['byId', productId], updates.product),
    };
  }

  return products.get('byId').reduce(applyOperationsToProduct, { actions: actionsToDispatch, products });
}
